/**
 * PRE-CHECKOUT REDIRECT
 * ============================================================================
 * Redirects checkout buttons to pre-checkout page for non-logged-in users
 * Preserves cart session throughout the process
 * ============================================================================
 */

(function() {
  'use strict';
  
  const PRE_CHECKOUT_PAGE = '/pages/pre-checkout';
  
  /**
   * Check if user is logged in
   */
  function isUserLoggedIn() {
    // Shopify provides customer object in window
    return window.Shopify && window.Shopify.customer && window.Shopify.customer.id;
  }
  
  /**
   * Intercept checkout button clicks
   */
  function interceptCheckoutButtons() {
    // Find all checkout buttons
    const checkoutButtons = document.querySelectorAll('button[name="checkout"], .checkout-button');
    
    checkoutButtons.forEach(button => {
      const form = button.closest('form');
      
      if (form) {
        form.addEventListener('submit', function(e) {
          // If user is not logged in, redirect to pre-checkout page
          if (!isUserLoggedIn()) {
            e.preventDefault();
            window.location.href = PRE_CHECKOUT_PAGE;
          }
          // If user is logged in, allow normal checkout
        });
      }
    });
  }
  
  /**
   * Initialize on DOM ready
   */
  function init() {
    // Run on page load
    interceptCheckoutButtons();
    
    // Re-run when cart drawer opens (for dynamic content)
    document.addEventListener('cart:updated', function() {
      setTimeout(interceptCheckoutButtons, 100);
    });
    
    // Re-run when cart page updates
    const cartObserver = new MutationObserver(function() {
      interceptCheckoutButtons();
    });
    
    const cartContainer = document.querySelector('.cart-drawer, .main-cart');
    if (cartContainer) {
      cartObserver.observe(cartContainer, {
        childList: true,
        subtree: true
      });
    }
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
})();
